export default __webpack_public_path__ + "9399db3ae259c06ee87fce8abccae44e.svg";